import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, ShoppingBag, X } from "lucide-react";
import { useCart } from "../context/CartContext";
import CartSheet from "./CartSheet";

const navLinks = [
  { to: "/shop", label: "F1 Frames" },
  { to: "/fortnite", label: "Fortnite" },
  { to: "/sports", label: "Sports" },
  { to: "/coming-soon", label: "Coming Soon" },
  { to: "/custom-request", label: "Custom Build" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const { count, setOpen } = useCart();
  const [mobile, setMobile] = useState(false);
  const navigate = useNavigate();

  const linkBase =
    "text-xs font-mono uppercase tracking-[0.18em] text-zinc-400 hover:text-white transition-colors";

  return (
    <>
      <div
        className="bg-[#FF2800] text-white overflow-hidden"
        data-testid="sale-banner"
      >
        <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-center gap-2 text-center">
          <span className="af-mono text-[10px] sm:text-[11px] font-bold uppercase tracking-[0.2em]">
            🔥 30% OFF SITEWIDE — SALE ENDING SOON · ₹500 OFF ORDERS OVER ₹10,000
          </span>
        </div>
      </div>
      <header
        className="sticky top-0 z-50 border-b border-white/10 backdrop-blur-xl bg-black/70"
        data-testid="site-header"
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center gap-2 group"
            data-testid="brand-logo-link"
            aria-label="Apex Designs — home"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_frame-racer-depot/artifacts/ewmv2tas_image.png"
              alt="Apex Designs"
              style={{ mixBlendMode: "screen" }}
              className="h-10 md:h-11 w-auto"
            />
            <span className="af-mono text-[10px] text-zinc-500 ml-1 hidden sm:inline">
              /// IND
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                className={({ isActive }) =>
                  `${linkBase} ${isActive ? "text-white" : ""}`
                }
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={() => setOpen(true)}
              className="relative inline-flex items-center gap-2 border border-white/15 px-3 py-2 hover:border-white/40 transition-colors"
              data-testid="open-cart-button"
            >
              <ShoppingBag size={16} strokeWidth={1.5} />
              <span className="af-mono text-[11px] uppercase tracking-widest">
                Cart
              </span>
              {count > 0 && (
                <span
                  className="absolute -top-2 -right-2 min-w-[20px] h-5 px-1 rounded-full bg-[#FF2800] text-[10px] font-bold flex items-center justify-center"
                  data-testid="cart-count-badge"
                >
                  {count}
                </span>
              )}
            </button>
            <button
              type="button"
              className="md:hidden inline-flex items-center justify-center w-10 h-10 border border-white/15"
              onClick={() => setMobile((v) => !v)}
              data-testid="open-mobile-menu-button"
              aria-label="Toggle menu"
            >
              {mobile ? <X size={18} /> : <Menu size={18} />}
            </button>
          </div>
        </div>

        {mobile && (
          <div className="md:hidden border-t border-white/10 bg-black/95">
            <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-4">
              {navLinks.map((l) => (
                <button
                  key={l.to}
                  type="button"
                  onClick={() => {
                    setMobile(false);
                    navigate(l.to);
                  }}
                  className="text-left text-sm font-mono uppercase tracking-[0.18em] text-zinc-300"
                  data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {l.label}
                </button>
              ))}
            </div>
          </div>
        )}
      </header>
      <CartSheet />
    </>
  );
}
